import config from "@/config/config";
import { ListUploadResponse, UploadRequest, UploadResponse } from "@/domain/upload.model";
import httpClient from "@/helpers/http-client";
import { headers } from "./headers";

export class UploadService {
  private static urlApiBase = config.url_api_base;

  static upload = (data: UploadRequest): Promise<UploadResponse> => {
    const formData = new FormData();

    formData.append("type", data.type);
    formData.append("file", data.file as Blob);

    return httpClient
      .request<UploadResponse>({
        url: `${this.urlApiBase}/upload`,
        method: "POST",
        body: formData,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static getFiles = (): Promise<ListUploadResponse[]> => {
    return httpClient
      .request<ListUploadResponse[]>({
        url: `${this.urlApiBase}/upload`,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
